import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { TranslationToEnglish } from "./translation/en/index";

const resources = {
  en: {
    translation: TranslationToEnglish,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    supportedLngs: ["en", "ar"],
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    // Options for language detector
    detection: {
      order: ["path", "cookie", "htmlTag"],
      caches: ["cookie"],
    },
  });

export default i18n;
